// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const documentSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  projectId: z.string().max(100).optional(),
  milestoneId: z.string().max(100).optional(),
  taskId: z.string().max(100).optional(),
  codebaseId: z.string().max(100).optional(),
  documentType: z.string().max(200),
  title: z.string().max(500),
  content: z.string().max(100000).optional(),
  storage: z.record(z.string(), z.unknown()).optional(),
  documentVersion: z.number().int(),
  approved: z.boolean(),
  approvedAt: z.string().max(200).optional(),
  approvedBy: z.string().max(200).optional(),
  tenantId: z.string().max(100).optional(),
})

export type DocumentInput = z.infer<typeof documentSchema>
